import { Link } from "react-router-dom";
import { LegalSection, sectionId } from "@/components/legal/LegalSection";
import { LEGAL_UPDATED } from "@/data/legal";
import { scrollToId } from "@/hooks/useLenis";
import { Seo } from "@/components/seo/Seo";
import { SEO } from "@/data/seo";

const RELATED = [
  { id: "termini", to: "/termini", label: "Termini e condizioni" },
  { id: "privacy", to: "/privacy", label: "Privacy policy" },
  { id: "cookie", to: "/cookie", label: "Cookie policy" },
  { id: "contatti", to: "/contatti", label: "Contatti" },
];

const Toc = ({ doc }) => (
  <nav aria-label="Indice" className="rounded-3xl border border-copper/20 bg-cream p-6 lg:sticky lg:top-36" data-testid="legal-toc">
    <p className="eyebrow">Indice</p>
    <ol className="mt-4 space-y-2">
      {doc.sections.map((s, i) => (
        <li key={s.h}>
          <button type="button" onClick={() => scrollToId(sectionId(doc.id, i))} data-testid={`legal-toc-${i + 1}`} className="text-left text-[15px] leading-snug text-navy transition-colors hover:text-copper-deep">
            {s.h}
          </button>
        </li>
      ))}
    </ol>
  </nav>
);

export default function Legal({ doc }) {
  return (
    <div className="bg-ivory pb-28 pt-40" data-testid={`legal-page-${doc.id}`}>
      <Seo {...SEO[doc.id]} />
      <div className="container-pf">
        <p className="eyebrow max-w-3xl leading-relaxed">{doc.eyebrow}</p>
        <h1 className="mt-5 font-display text-4xl font-medium leading-[1.05] text-navy sm:text-5xl lg:text-6xl" data-testid="legal-title">{doc.title}</h1>
        <p className="mt-6 max-w-3xl text-lg leading-relaxed text-slate2">{doc.intro}</p>
        <p className="mt-4 text-[14px] text-slate2" data-testid="legal-updated">Ultimo aggiornamento: {LEGAL_UPDATED}</p>
        <div className="mt-14 grid gap-12 lg:grid-cols-12">
          <aside className="lg:col-span-4"><Toc doc={doc} /></aside>
          <div className="space-y-10 lg:col-span-8">
            {doc.sections.map((s, i) => <LegalSection key={s.h} docId={doc.id} section={s} index={i} />)}
            <div className="flex flex-wrap gap-3 border-t border-copper/20 pt-10">
              {RELATED.filter((r) => r.id !== doc.id).map((r) => (
                <Link key={r.id} to={r.to} data-testid={`legal-related-${r.id}`} className="inline-flex h-12 items-center rounded-full border border-navy/20 px-6 text-[16px] text-navy transition-colors hover:bg-navy hover:text-ivory">
                  {r.label}
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
